import { HotTopic2 } from "../../";

const FooterRight2 = () => {
    // داده‌های موضوعات داغ
    const hotTopics = [
        { id: 1, topic: "افسانه بازار آزاد", url: "/tag/افسانه-بازار-آزاد" },
        { id: 2, topic: "فلاکت غرب", url: "/tag/فلاکت-غرب" },
        { id: 3, topic: "خودرو", url: "/tag/خودرو" },
        { id: 4, topic: "خودکفایی", url: "/tag/خودکفایی" },
        { id: 5, topic: "کشاورزی", url: "/tag/کشاورزی" }
    ];

    return (
        <div className="mt-12 pl-6 w-[100%] md:w-full">
            <div className="mb-7 text-center">
                <p className="text-nextColor font-IRANYekanExtra text-[20px]">
                    موضوعات داغ
                </p>
            </div>
            <div className="flex flex-wrap align-middle justify-center">
                {hotTopics.map((topic) => (
                    <a href={topic.url} key={topic.id}>
                        <HotTopic2 topic={topic.topic} />
                    </a>
                ))}
            </div>
        </div>
    );
};

export default FooterRight2;
